"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isEventDataAttrsConstructor(value) {
    return typeof value === 'function';
}
exports.isEventDataAttrsConstructor = isEventDataAttrsConstructor;
function isEventDeclaration(value) {
    return Boolean(value);
}
exports.isEventDeclaration = isEventDeclaration;
function isNodeAttrsConstructor(value) {
    return typeof value === 'function';
}
exports.isNodeAttrsConstructor = isNodeAttrsConstructor;
